import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import moment from "moment-jalaali";
import Api from "../../utils/api";
import ExcelJS from "exceljs";
import {Loading} from "../index";

const ProductPinsExcel = ({ product_id, object }) => {
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        object.excel_export = 1;
        try {
            const response = await new Api().get(
                `/products/${product_id}/pins`,
                object
            );
            if (response && response.pins) {
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet("Product Pins");

                worksheet.columns = [
                    { header: "ردیف", key: "id", width: 10 },
                    { header: "اپراتور", key: "operator", width: 25 },
                    { header: "شماره سفارش", key: "order_id", width: 20 },
                    { header: "تعداد کسر شده", key: "dec_count", width: 15 },
                    { header: "تعداد اضافه شده", key: "inc_count", width: 15 },
                    { header: "جمع", key: "total", width: 10 },
                    { header: "تاریخ ثبت", key: "created_at", width: 20 },
                    { header: "شماره سند", key: "document_number", width: 20 },
                    { header: "تاریخ کارتکس", key: "depot_date", width: 20 },
                ];

                response.pins.forEach((entity) => {
                    worksheet.addRow({
                        id: entity.id,
                        operator: entity.operator
                            ? `${entity.operator.name} ${entity.operator.family}`
                            : "-",
                        order_id: entity.order_id || "-",
                        dec_count: parseInt(entity.dec_count),
                        inc_count: parseInt(entity.inc_count),
                        total: parseInt(entity.total),
                        created_at: moment(entity.created_at)
                            .locale("fa")
                            .format("jYYYY/jMM/jDD HH:mm:ss"),
                        document_number: entity.document_number || "-",
                        depot_date: entity.depot_date
                            ? moment(entity.depot_date)
                                .locale("fa")
                                .format("jYYYY/jMM/jDD HH:mm:ss")
                            : "-",
                    });
                });

                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], {
                    type:
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.download = `product_${product_id}_${moment().unix()}.xlsx`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } catch (error) {
            console.error("Error exporting pins:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <IconButton onClick={fetchData} disabled={loading}>
            {loading && <Loading />}
            <ImportExportIcon />
        </IconButton>
    );
};

export default ProductPinsExcel;
